import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../primitives/Select/components/Placeholder/components/Container.js';
const PlaceholderComponent = props => {
  const {
    children,
    innerProps,
    hasValue,
    selectProps,
    className
  } = props;
  const {
    isPinned,
    size,
    menuIsOpen,
    inputValue,
    isSearchable,
    controlIcon
  } = selectProps;
  return _jsx(Container, {
    ...innerProps,
    className: className,
    size: size,
    controlIcon: !!controlIcon,
    shrink: (isPinned || isSearchable) && (hasValue || inputValue || menuIsOpen),
    htmlFor: selectProps.id,
    children: children
  });
};
export const Placeholder = /*#__PURE__*/_styled(PlaceholderComponent, process.env.NODE_ENV === "production" ? {
  target: "e31xcnm0"
} : {
  target: "e31xcnm0",
  label: "Placeholder"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVF3RCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi8uLi9wcmltaXRpdmVzL1NlbGVjdC9jb21wb25lbnRzL1BsYWNlaG9sZGVyL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmNvbnN0IFBsYWNlaG9sZGVyQ29tcG9uZW50ID0gKHByb3BzKSA9PiB7XG4gICAgY29uc3QgeyBjaGlsZHJlbiwgaW5uZXJQcm9wcywgaGFzVmFsdWUsIHNlbGVjdFByb3BzLCBjbGFzc05hbWUgfSA9IHByb3BzO1xuICAgIGNvbnN0IHsgaXNQaW5uZWQsIHNpemUsIG1lbnVJc09wZW4sIGlucHV0VmFsdWUsIGlzU2VhcmNoYWJsZSwgY29udHJvbEljb24gfSA9IHNlbGVjdFByb3BzO1xuICAgIHJldHVybiAoX2pzeChDb250YWluZXIsIHsgLi4uaW5uZXJQcm9wcywgY2xhc3NOYW1lOiBjbGFzc05hbWUsIHNpemU6IHNpemUsIGNvbnRyb2xJY29uOiAhIWNvbnRyb2xJY29uLCBzaHJpbms6IChpc1Bpbm5lZCB8fCBpc1NlYXJjaGFibGUpICYmIChoYXNWYWx1ZSB8fCBpbnB1dFZhbHVlIHx8IG1lbnVJc09wZW4pLCBodG1sRm9yOiBzZWxlY3RQcm9wcy5pZCwgY2hpbGRyZW46IGNoaWxkcmVuIH0pKTtcbn07XG5leHBvcnQgY29uc3QgUGxhY2Vob2xkZXIgPSBzdHlsZWQoUGxhY2Vob2xkZXJDb21wb25lbnQpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9aW5kZXguanMubWFwIl19 */");